import React from 'react';
import _ from 'lodash';
import {
    Card,
    CardBody,
    CardHeader,
    Collapse,
    FormGroup,
    Input,
    Label
} from 'reactstrap';
import qs from 'qs';
import { withRouter } from 'react-router-dom';

import CollapseButton from '../dumb/collapseButton';
import baseFilter from './baseFilter';

class CpvFilter extends baseFilter {

    constructor(props) {
        super(props);

        this.renderCpvCheckboxes =
            this.renderCpvCheckboxes.bind(this);

        this.toggleCheckbox =
            this.toggleCheckbox.bind(this);

        this.updateAPIURL =
            this.updateAPIURL.bind(this);

        this.processResponse =
            this.processResponse.bind(this);

        this.toggleCollapse =
            this.toggleCollapse.bind(this);

        this.state = {
            filters: {
                Yes: {
                    active: false,
                    count: undefined
                }
            },
            isOpen: false,
            fields: ['Yes'],
            activeCount: 0
        };

        this.aggregates = {
            has_cpv: 'count'
        };
    }

    static getActiveFiltersFromQS(
        qs_obj,
        field,
        defaultValue = [],
        sep = '_'
    ) {
        return field in qs_obj
            ? _.split(_.get(qs_obj, field), sep)
            : defaultValue;
    }

    static getDerivedStateFromProps(newprops, oldstate) {

        const querystring = qs.parse(
            newprops.location.search,
            { ignoreQueryPrefix: true }
        );

        const activeFilters =
            CpvFilter.getActiveFiltersFromQS(
                querystring,
                'cpv'
            );

        return {
            filters: {
                Yes: {
                    ...oldstate.filters.Yes,
                    active: activeFilters.indexOf('Yes') >= 0
                }
            },
            activeCount: activeFilters.length
        };
    }

    updateAPIURL(api_qs, newlistprops) {

        const new_qs = qs.parse(
            newlistprops.location.search,
            { ignoreQueryPrefix: true }
        );

        const activeFilters =
            CpvFilter.getActiveFiltersFromQS(
                new_qs,
                'cpv'
            );

        if (activeFilters.length > 0) {

            const filter_qs = {
                name: 'has_cpv',
                op: 'eq',
                val: true
            };

            api_qs.filter = [
                ...(api_qs.filter || []),
                filter_qs
            ];
        }

        return _.merge(
            api_qs,
            { agg: this.aggregates }
        );
    }

    getFromResponse(resp) {

        const value = _.get(
            resp,
            'meta.agg.has_cpv'
        );

        if (_.isNumber(value)) {
            return value;
        }

        return (
            _.get(value, 'true') ??
            _.get(value, 'True') ??
            _.get(value, 'count.true') ??
            _.get(value, 'count.True')
        );
    }

    processResponse(response) {

        const count = this.getFromResponse(response);

        this.setState({
            filters: {
                Yes: {
                    ...this.state.filters.Yes,
                    count
                }
            }
        });
    }

    toggleCollapse() {
        this.setState({
            isOpen: !this.state.isOpen
        });
    }

    toggleCheckbox(event) {

        const cpv = event.target.name;

        const current_qs = qs.parse(
            window.location.search,
            { ignoreQueryPrefix: true }
        );

        let selected = (
            'cpv' in current_qs
        )
            ? _.split(current_qs.cpv, '_')
            : [];

        if (event.target.checked) {

            if (!selected.includes(cpv)) {
                selected.push(cpv);
            }

        } else {

            selected = selected.filter(
                item => item !== cpv
            );
        }

        current_qs.cpv =
            selected.length > 0
                ? _.join(selected.sort(), '_')
                : undefined;

        current_qs.page = undefined;

        this.props.history.push(
            window.location.pathname +
            qs.stringify(current_qs, {
                addQueryPrefix: true
            })
        );
    }

    renderCpvCheckboxes() {

        return _.map(
            _.toPairs(this.state.filters),
            ([cpv, details]) => (

                <FormGroup check key={cpv}>

                    <Input
                        type="checkbox"
                        name={cpv}
                        onChange={this.toggleCheckbox}
                        checked={!!details.active}
                    />

                    {' '}

                    <Label
                        className="ml-4 mt-1"
                        check
                    >
                        {cpv}

                        {details.count !== undefined && (
                            <span className="secondary">
                                {' '}({details.count})
                            </span>
                        )}
                    </Label>

                </FormGroup>
            )
        );
    }

    componentDidMount() {
        this.props.registerResponse(this.processResponse);
        this.props.registerRequest(this.updateAPIURL);
    }

    componentWillUnmount() {
        this.props.unregisterResponse(this.processResponse);
        this.props.unregisterRequest(this.updateAPIURL);
    }

    render() {

        return (
            <Card className="genetic-filters mb-2 z0 hover">

                <CardHeader
                    className="justify-content-between d-flex"
                    onClick={this.toggleCollapse}
                >

                    <div className="d-inline w-50">
                        Cancer Predisposition Variants
                    </div>

                    <div className="d-inline-block">
                        {this.state.activeCount > 0 && (
                            <strong>
                                {this.state.activeCount} active
                            </strong>
                        )}
                    </div>

                    <CollapseButton
                        isOpen={this.state.isOpen}
                        onClick={this.toggleCollapse}
                    />

                </CardHeader>

                <Collapse isOpen={this.state.isOpen}>
                    <CardBody>
                        {this.renderCpvCheckboxes()}
                    </CardBody>
                </Collapse>

            </Card>
        );
    }
}

export default withRouter(CpvFilter);